import { motionValue } from "motion/react";
import { useEffect, type RefObject } from "react";

export const HEADER_PROBE_PX = 80;

// How much of the hero photo sits behind the header: the scroll story fades it,
// a static hero flips it. 0 when no hero is on screen.
export const heroHeader = {
  photoOpacity: motionValue(0),
};

/** Keeps the header transparent while the given static hero is behind it. */
export function useHeroPhotoProbe(ref: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const update = () => {
      const rect = ref.current?.getBoundingClientRect();
      heroHeader.photoOpacity.set(
        rect && rect.bottom > HEADER_PROBE_PX ? 1 : 0,
      );
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      heroHeader.photoOpacity.set(0);
    };
  }, [ref]);
}
